import { createFileRoute } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { RecordColumn } from "@/components/common/record"
import { OwnershipControllers } from "@/features/ownership/components/ownership-controllers"
import { OwnershipEmptyState } from "@/features/ownership/components/ownership-empty-state"
import { OwnershipHeaderActions } from "@/features/ownership/components/ownership-header-actions"
import { OwnershipStatus } from "@/features/ownership/components/ownership-status"
import { OwnershipStructure } from "@/features/ownership/components/ownership-structure"
import { firmOwnershipCopy } from "@/lib/firm-ownership-copy"
import { ownershipQueries } from "@/queries/ownership"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/firms/$firmId/ownership/"
)({
  staticData: { attention: "firm.ownership" },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(ownershipQueries.firm(params.firmId)),
  component: FirmOwnershipPage,
})

function FirmOwnershipPage() {
  const { firmId } = Route.useParams()

  return (
    <>
      <PageHeader
        title={firmOwnershipCopy.page}
        actions={<OwnershipHeaderActions firmId={firmId} />}
      />
      <OwnershipEmptyState firmId={firmId} />
      <RecordColumn>
        <OwnershipStatus firmId={firmId} />
        <OwnershipControllers firmId={firmId} />
        <OwnershipStructure firmId={firmId} />
      </RecordColumn>
    </>
  )
}
